(function () {
  'use strict';
  function init(root) {
    if (root.dataset.mhmReady) return;
    root.dataset.mhmReady = '1';
    var tabs = root.querySelectorAll('[data-mhm-tab]');
    var panels = root.querySelectorAll('[data-mhm-panel]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.dataset.mhmPanel !== t.dataset.mhmTab; });
      });
    });
    root.querySelectorAll('[data-mhm-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = root.querySelector('[data-mhm-panel]:not([hidden]) [data-mhm-row]');
        if (!row) return;
        var card = row.firstElementChild;
        var w = card ? card.getBoundingClientRect().width + 20 : row.clientWidth;
        row.scrollBy({ left: parseInt(b.dataset.mhmStep, 10) * w * 2, behavior: 'smooth' });
      });
    });
  }
  function boot() { document.querySelectorAll('[data-mhm-tabs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
